// extracted by mini-css-extract-plugin
export default {"dialogmainwrapper":"dialogDiagnosisCodesAddUpdate_dialogmainwrapper__OA1pz","btns":"dialogDiagnosisCodesAddUpdate_btns__535JI"};